import { render, staticRenderFns } from "./PanelGraficosRebanho.vue?vue&type=template&id=f513136c&scoped=true&"
import script from "./PanelGraficosRebanho.vue?vue&type=script&lang=js&"
export * from "./PanelGraficosRebanho.vue?vue&type=script&lang=js&"
import style0 from "./PanelGraficosRebanho.vue?vue&type=style&index=0&id=f513136c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f513136c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VDivider,VExpansionPanel,VExpansionPanelContent,VFlex,VLayout})
